<div class="preamble">
  <h2>Review notification</h2>
</div>
<h3>Landholder details</h3>
<table class="table-fixed w-100">
  <tbody>
    <tr>
      <th>Name</th>
      <td>
        {{landholderDetails?.firstName}}
        {{landholderDetails?.middleName}}
        {{landholderDetails?.lastName}}
      </td>
    </tr>
    @if (!!landholderDetails?.companyName) {
      <tr>
        <th>Company name</th>
        <td>{{landholderDetails?.companyName}}</td>
      </tr>
    }
    @if (states) {
      <tr>
        <th>Home address</th>
        <td>
          {{landholderDetails?.homeAddress?.line1}}<br />
          @if (!!landholderDetails?.homeAddress?.line2) {
            <span>{{landholderDetails?.homeAddress?.line2}}<br /></span>
          }
          {{landholderDetails?.homeAddress?.suburb}}<br />
          {{getState(landholderDetails?.homeAddress?.stateId!)}} {{landholderDetails?.homeAddress?.postcode}}
        </td>
      </tr>
    }
    @if (states) {
      <tr>
        <th>Mailing address</th>
        <td>
          @if (landholderDetails?.mailingAddressSameAsPhysicalAddress) {
            <div>
              Same as home address
            </div>
          }
          @if (!landholderDetails?.mailingAddressSameAsPhysicalAddress) {
            <div>
              {{landholderDetails?.mailingAddress?.line1}}<br />
              @if (!!landholderDetails?.mailingAddress?.line2) {
                <span
                >{{landholderDetails?.mailingAddress?.line2}}<br /></span>
              }
              {{landholderDetails?.mailingAddress?.suburb}}<br />
              {{getState(landholderDetails?.mailingAddress?.stateId!)}} {{landholderDetails?.mailingAddress?.postcode}}
            </div>
          }
        </td>
      </tr>
    }
    @if (!!landholderDetails?.phone) {
      <tr>
        <th>Phone</th>
        <td>{{landholderDetails?.phone}}</td>
      </tr>
    }
    @if (!!landholderDetails?.mobile) {
      <tr>
        <th>Mobile</th>
        <td>{{landholderDetails?.mobile}}</td>
      </tr>
    }
    <tr>
      <th>Email</th>
      <td>{{landholderDetails?.email}}</td>
    </tr>
  </tbody>
</table>
<!-- this notifier details needs to be fixed in future PR -->
@if (!landholderConfirmationDetails?.areYouTheLandholder && !landholderConfirmationDetails?.areYouLandsOfficer) {
  <div>
    <h3>Notifier details</h3>
    <table class="table-fixed w-100">
      <tr>
        <th>Name</th>
        <td>
          {{notifierDetails?.firstName}}
          {{notifierDetails?.middleName}}
          {{notifierDetails?.lastName}}
        </td>
      </tr>
      @if (!!notifierDetails?.companyName) {
        <tr>
          <th>Company name</th>
          <td>{{notifierDetails?.companyName}}</td>
        </tr>
      }
      @if (states) {
        <tr>
          <th>Home address</th>
          <td>
            {{notifierDetails?.homeAddress?.line1}}<br />
            @if (!!notifierDetails?.homeAddress?.line2) {
              <span>{{notifierDetails?.homeAddress?.line2}}<br /></span>
            }
            {{notifierDetails?.homeAddress?.suburb}}<br />
            {{getState(notifierDetails?.homeAddress?.stateId!)}} {{notifierDetails?.homeAddress?.postcode}}
          </td>
        </tr>
      }
      @if (states) {
        <tr>
          <th>Mailing address</th>
          <td>
            @if (notifierDetails?.mailingAddressSameAsPhysicalAddress) {
              <div>
                Same as home address
              </div>
            }
            @if (!notifierDetails?.mailingAddressSameAsPhysicalAddress) {
              <div>
                {{notifierDetails?.mailingAddress?.line1}}<br />
                @if (!!notifierDetails?.mailingAddress?.line2) {
                  <span>{{notifierDetails?.mailingAddress?.line2}}<br /></span>
                }
                {{notifierDetails?.mailingAddress?.suburb}}<br />
                {{getState(notifierDetails?.mailingAddress?.stateId!)}} {{notifierDetails?.mailingAddress?.postcode}}
              </div>
            }
          </td>
        </tr>
      }
      @if (!!notifierDetails?.phone) {
        <tr>
          <th>Phone</th>
          <td>{{notifierDetails?.phone}}</td>
        </tr>
      }
      @if (!!notifierDetails?.mobile) {
        <tr>
          <th>Mobile</th>
          <td>{{notifierDetails?.mobile}}</td>
        </tr>
      }
      <tr>
        <th>Email</th>
        <td>{{notifierDetails?.email}}</td>
      </tr>
    </table>
  </div>
}

@if (!landholderConfirmationDetails?.areYouTheLandholder && landholderConfirmationDetails?.areYouLandsOfficer) {
  <div>
    <h3>Department of Natural Resources and Mines, Manufacturing and Regional and Rural Development Officer details</h3>
    <table class="table-fixed w-100">
      <tbody>
        <tr>
          <th>User ID</th>
          <td>{{notifierDetails?.username}}</td>
        </tr>
        <tr>
          <th>Name</th>
          <td>
            {{notifierDetails?.firstName}}
            {{notifierDetails?.middleName}}
            {{notifierDetails?.lastName}}
          </td>
        </tr>
        <tr>
          <th>Phone</th>
          <td>{{notifierDetails?.phone}}
          </tr>
          <tr>
            <th>Email</th>
            <td>{{notifierDetails?.email}}
            </tr>
            <tr>
              <th>Location</th>
              <td>{{notifierDetails?.location}}
              </tr>
              @if (notifierDetails?.canAttachEvidenceOfConsent &&
                (notifierDetails?.evidenceOfConsentFileNames ?? []).length > 0) {
                <tr>
                  <th>Copy of notification</th>
                  <td>
                    @for (consent of notifierDetails?.evidenceOfConsentFileNames; track consent) {
                      <ul>
                        <li><code>{{consent}}</code> [<a (click)="downloadEvidenceOfConsentFile(consent)">Download</a>]</li>
                      </ul>
                    }
                  </td>
                </tr>
              }
              @if (!notifierDetails?.canAttachEvidenceOfConsent) {
                <tr>
                  <th>Nature of notification</th>
                  <td><em>{{notifierDetails?.natureOfConsent}}</em></td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }

      <h3>Property details</h3>
      <table class="table-fixed w-100">
        <tbody>
          <tr>
            <th>Lot on plan</th>
            <td>{{lotOnPlanDetails?.lot?.toUpperCase()}} / {{lotOnPlanDetails?.plan?.toUpperCase()}}</td>
          </tr>
          <tr>
            <th>Area</th>
            <td>{{lotOnPlanDetails?.area| number}} hectares</td>
          </tr>
          <tr>
            <th>Tenure</th>
            <td>{{lotOnPlanDetails?.tenure}}</td>
          </tr>
          <tr>
            <th>Local Government Areas</th>
            <td>
              @for (lga of lotOnPlanDetails?.localGovernmentAreas; track lga) {
                <span>{{lga}}<br /></span>
              }
            </td>
          </tr>
          <tr>
            <th>Categories</th>
            <td>
              @for (category of lotOnPlanDetails?.categories; track category) {
                <span>{{category}}<br /></span>
              }
            </td>
          </tr>
          <tr>
            <th>Bioregions</th>
            <td>
              @for (bioregion of lotOnPlanDetails?.bioregions; track bioregion) {
                <span>{{bioregion}}<br /></span>
              }
            </td>
          </tr>
        </tbody>
      </table>

      <h3>Notification type</h3>
      <table class="table-fixed w-100">
        <tbody>
          <tr>
            <th>Categories</th>
            <td [textContent]="categoryDisplayValue"></td>
          </tr>
          <tr>
            <th>Purpose</th>
            <td>{{purposeDetails?.purpose?.purposeDescription}}</td>
          </tr>
          @if (!!regionalEcosystems && regionalEcosystems !== null) {
            <tr>
              <th>Regional ecosystems</th>
              <td>
                @for (category of categoryDetails; track category) {
                  <div>
                    <strong>Category {{category.categoryCode}}</strong>
                    @if (regionalEcosystems) {
                      <div>
                        @for (re of regionalEcosystemsToDisplay; track re) {
                          <div>
                            @if (re.categoryPurposeId == category.categoryPurposeId) {
                              <div>
                                {{re.regionalEcosystem}}
                              </div>
                            }
                          </div>
                        }
                        @for (re of regionalEcosystems.regionalEcosystemsAddedFromSearchResults; track re) {
                          <div>
                            @if (re.categoryPurposeId == category.categoryPurposeId) {
                              <div>
                                {{re.regionalEcosystem}} <sup>^</sup>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
              </td>
            </tr>
          }
          @if (regionalEcosystems && regionalEcosystems.regionalEcosystemsAddedFromSearchResults.length > 0) {
            <tr>
              <th></th>
              <td><sup>^</sup> Regional Ecosystem has been manually entered by notifier.</td>
            </tr>
          }
          @if (!!regionalEcosystemStatuses?.selectedStatusGroups!) {
            <tr>
              <th>Regional ecosystem statuses</th>
              <td>
                @for (statusGroup of regionalEcosystemStatuses?.selectedStatusGroups; track statusGroup) {
                  <span>
                    <strong [textContent]="statusGroup.category"></strong>
                    @for (status of statusGroup.statuses; track status) {
                      <div>
                        <span [textContent]="status.code"></span>
                        @if (!!status.message) {
                          <small> <sup>*{{regionalEcosystemStatuses?.messages!.indexOf(status.message) +
                          1}}</sup></small>
                        }
                      </div>
                    }
                  </span>
                }
                <ol>
                  @for (message of regionalEcosystemStatuses?.messages; track message) {
                    <li [innerHtml]="message"></li>
                  }
                </ol>
              </td>
            </tr>
          }
          @if (activitiesDetails?.selectedActivities) {
            <tr>
              <th>Activities</th>
              <td>
                @for (activity of removeDuplicates(activitiesDetails?.selectedActivities!); track activity) {
                  <span
                  >{{activity.description}}<br /></span>
                }
              </td>
            </tr>
          }

          <!-- when NFP feature is not enabled there is only a single reason value which is free text -->
          @if (!!reasonText) {
            <tr>
              <th>Reason</th>
              <td [ifFeatureEnabled]="FeatureFlags.NFP2019">
                <ul>
                  @for (reason of reasonText; track reason) {
                    <li>{{reason}}</li>
                  }
                </ul>
              </td>
              <td [ifFeatureDisabled]="FeatureFlags.NFP2019">{{reasonText[0]}}
              </td>
            </tr>
          }
          @if (!!isCoastalResponse && isCoastalResponse !== null) {
            <tr>
              <td colspan="2">
                @if (isCoastalResponse) {
                  <div>The lot is within a <b>coastal</b> area.</div>
                }
                @if (!isCoastalResponse) {
                  <div>The lot is within a <b>non-coastal</b> area.</div>
                }
              </td>
            </tr>
          }
          @if (!!channelDimensionsDetails && channelDimensionsDetails !== null) {
            <tr>
              <th>Channel dimensions</th>
              <td>
                Width: {{channelDimensionsDetails.width}} m
              </td>
            </tr>
          }
        @if (!!exchangeAreaData && !!exchangeAreaData.exchangeAreaFileReferenceNumber) {
          <tr>
            <th>Exchange Area</th>
            <td>
              Exchange Area reference Number: {{exchangeAreaData.exchangeAreaFileReferenceNumber}}
            </td>
          </tr>
        }
          @if (notificationAreaDetails?.area! > 0) {
            <tr>
              <th>Clearing area size</th>
              <td>{{notificationAreaDetails?.area|number}} hectares</td>
            </tr>
          }
          @if (!!notificationAreaDetails && !!notificationAreaDetails.mapFileNames
            && notificationAreaDetails.mapFileNames.length > 0) {
            <tr>
              <th>Map or shape file</th>
              <td>
                @for (map of notificationAreaDetails.mapFileNames; track map) {
                  <ul>
                    <li><code>{{map}}</code> [<a (click)="downloadMapFile(map)">Download</a>]</li>
                  </ul>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>

      @if (acknowledgements) {
        <div>
          <h3>Acknowledgements</h3>
          <table class="table-fixed w-100">
            <tbody>
              @for (acknowledgement of acknowledgements; track acknowledgement) {
                <tr>
                  <td [innerHtml]="acknowledgement"></td>
                  <td>Acknowledged</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }

      <br />
      <ul class="actions">
        <li>
          <input class="qg-btn btn-global-secondary" type="button" (click)="previous()" value="Previous" />
        </li>
        <li>
          <em><input class="qg-btn btn-primary" type="submit" (click)="next()" value="Next" /></em>
        </li>
      </ul>
      <ul class="actions">
        <li>
          <a href (click)="cancel()">Cancel</a>
        </li>
      </ul>

